import React, { useLayoutEffect, useMemo } from 'react';
import { ScrollView, StyleSheet } from 'react-native';
import { Indicator } from 'design-system/Indicator';
import { rem } from 'design-system/values';
import { SettingsSection } from 'design-system/SettingsSection';
import { SettingsItem } from 'design-system/SettingsItem';
import { AppView } from 'design-system/AppView';
import withAnimatedNavigationHeader from 'design-system/hoc/withAnimatedNavigationHeader';
import Links from 'utils/links';
import { useAppSelector } from 'store/hooks';
import { selectFeatureFlag } from 'reducers/selectors';
import { HELP_ARTICLES_KEY } from 'features/help/constants';
import useAppFrameDimensions from 'hooks/useAppFrameDimensions';
import HelpScreenButton from 'features/help/components/HelpScreenButton';
import { isWeb } from '../../../constants';
const strings = {
    sectionName: 'Important stuff',
    policy: {
        title: 'Privacy Policy',
    },
    terms: {
        title: 'Main T&Cs',
    },
    support: {
        title: 'Support',
    },
};
const EMPTY_LINKS = [];
export const ImportantStuff = withAnimatedNavigationHeader(({ navigation, onScroll }) => {
    const userId = useAppSelector((state) => state.user.user.id);
    useLayoutEffect(() => {
        navigation.setOptions({
            headerRight: () => (<HelpScreenButton articlesKey={HELP_ARTICLES_KEY.SETTINGS}/>),
        });
    }, []);
    const extraTerms = useAppSelector((store) => selectFeatureFlag(store, 'terms').extra?.links || EMPTY_LINKS);
    const updatedTerms = useMemo(() => extraTerms.filter((term) => !term.title.toLowerCase().includes('emma wallet')), [extraTerms]);
    const { paddingHorizontalStyle } = useAppFrameDimensions(isWeb);
    if (userId === -1) {
        return (<AppView type="secondary" withFrame={false}>
          <Indicator dark/>
        </AppView>);
    }
    return (<AppView withFrame={false}>
        <ScrollView onScroll={onScroll} style={paddingHorizontalStyle} scrollEventThrottle={16}>
          <SettingsSection noMarginTop style={styles.marginTop}>
            <SettingsItem title={strings.terms.title} onPress={Links.openEmmaTerms}/>
            <SettingsItem title={strings.policy.title} onPress={Links.openEmmaPrivacy}/>
            {updatedTerms.map((term) => (<SettingsItem key={term.url} title={term.title} onPress={() => Links.openLink(term.url)}/>))}
          </SettingsSection>
        </ScrollView>
      </AppView>);
}, ({ colors }) => ({
    title: strings.sectionName,
    headerColorOutputRange: [
        colors.background.dark,
        colors.cards.onDark,
    ],
}));
const styles = StyleSheet.create({
    marginTop: {
        marginTop: rem(16),
    },
});
